import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable, timer } from 'rxjs';
import { distinctUntilChanged, expand, map } from 'rxjs/operators';

@Pipe({
    name: 'relativeTime',
    standalone: false
})
export class RelativeTimePipe implements PipeTransform {
  transform(value: number | null | undefined): Observable<string> {
    if (value == null) {
      return new Observable<string>((subscriber) => {
        subscriber.next('');
        subscriber.complete();
      });
    }

    const parsed = DateTime.fromSeconds(value).setLocale('pl');

    return timer(0).pipe(
      expand(() => timer(this.getNextDelay(parsed))),
      map(() => this.format(parsed)),
      distinctUntilChanged(),
    );
  }

  private format(date: DateTime): string {
    const now = DateTime.now();
    const diffMs = now.toMillis() - date.toMillis();

    if (diffMs >= 0 && diffMs < 60_000) {
      return 'przed chwilą';
    }

    return date.toRelative({ base: now }) ?? '';
  }

  private getNextDelay(date: DateTime): number {
    const now = DateTime.now();
    const diffMs = now.toMillis() - date.toMillis();

    if (diffMs < 0) {
      return 1_000;
    }

    if (diffMs < 60_000) {
      return 60_000 - diffMs + 100;
    }

    if (diffMs < 3_600_000) {
      return 60_000 - (diffMs % 60_000) + 100;
    }

    if (diffMs < 86_400_000) {
      return 3_600_000 - (diffMs % 3_600_000) + 100;
    }

    return 86_400_000 - (diffMs % 86_400_000) + 100;
  }
}
